var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGsense = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M14.038 9.697c.583.122 1.151.349 1.674.684l-1.732 2.046a2.365 2.365 0 0 0-2.78.62 2.31 2.31 0 0 0-.134 2.821l-1.732 2.047a4.923 4.923 0 0 1-.164-6.556L14.978 4.5l2.03 1.688zM16.828 17.731c-1.64 1.936-4.454 2.318-6.542.978l1.732-2.046a2.364 2.364 0 0 0 2.78-.62c.696-.822.722-1.98.134-2.821l1.732-2.046a4.92 4.92 0 0 1 .164 6.555"
  })));
};
export default SvgGsense;